var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/auth_login/components/password_reset_confirm.tsx";
import * as React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { resetPasswordConfirm } from 'soapbox/actions/security';
import { Button, Form, FormActions, FormGroup, Input } from 'soapbox/components/ui';
import PasswordIndicator from 'soapbox/features/verification/components/password-indicator';
import { useAppDispatch, useFeatures } from 'soapbox/hooks';
const token = new URLSearchParams(window.location.search).get('reset_password_token');
const messages = defineMessages({
  resetPasswordFail: {
    "id": "reset_password.fail",
    "defaultMessage": "Expired token, please try again."
  }
});
const Statuses = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};
const PasswordResetConfirm = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const {
    passwordRequirements
  } = useFeatures();
  const [password, setPassword] = React.useState('');
  const [status, setStatus] = React.useState(Statuses.IDLE);
  const [hasValidPassword, setHasValidPassword] = React.useState(passwordRequirements ? false : true);
  const isLoading = status === Statuses.LOADING;
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    setStatus(Statuses.LOADING);
    dispatch(resetPasswordConfirm(password, token)).then(() => setStatus(Statuses.SUCCESS)).catch(() => setStatus(Statuses.FAIL));
  }, [password]);
  const onChange = React.useCallback(event => {
    setPassword(event.target.value);
  }, []);
  const renderErrors = () => {
    if (status === Statuses.FAIL) {
      return [intl.formatMessage(messages.resetPasswordFail)];
    }
    return [];
  };
  if (status === Statuses.SUCCESS) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reset_password.header",
    defaultMessage: "Set New Password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Password",
    errors: renderErrors(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "password",
    name: "password",
    placeholder: "Password",
    onChange: onChange,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }), passwordRequirements && /*#__PURE__*/React.createElement(PasswordIndicator, {
    password: password,
    onChange: setHasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(FormActions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    theme: "primary",
    disabled: isLoading || !hasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "password_reset.reset",
    defaultMessage: "Reset password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 15
    }
  }))))));
};
export default PasswordResetConfirm;